import binanceLogo from "../../assets/wallets/binance.png"
import bitgetLogo from "../../assets/wallets/bitget.png"
import bybitLogo from "../../assets/wallets/bybit.png"
import coinbaseLogo from "../../assets/wallets/coinbase.png"
import geminiLogo from "../../assets/wallets/gemini.png"
import imtokenLogo from "../../assets/wallets/imtoken.png"
import metamaskLogo from "../../assets/wallets/metamask.png"
import okxLogo from "../../assets/wallets/okx.png"
import phantomLogo from "../../assets/wallets/phantom.png"
import mywalletLogo from "../../assets/wallets/mywallet.png"
import tronlinkLogo from "../../assets/wallets/tronlink.png"
import trustLogo from "../../assets/wallets/trust.png"
import type { FeaturedWallet } from "../types"

/**
 * Featured wallets in the connect modal.
 * Wallets with `tronProvider` support TRON when the user selects that network.
 * MetaMask supports TRON via the MetaMask multichain API (extension + mobile).
 * Coinbase / Gemini / Phantom do not support TRON.
 */
export const featuredWallets: FeaturedWallet[] = [
  {
    id: "binance",
    name: "Binance",
    chain: "evm",
    match: ["binance"],
    installUrl: "https://www.binance.com/en/web3wallet",
    logo: binanceLogo,
    tronProvider: "binance",
  },
  {
    id: "trust",
    name: "Trust Wallet",
    chain: "evm",
    match: ["trust"],
    installUrl: "https://trustwallet.com/download",
    logo: trustLogo,
    tronProvider: "trust",
  },
  {
    id: "okx",
    name: "OKX",
    chain: "evm",
    match: ["okx"],
    installUrl: "https://www.okx.com/web3",
    logo: okxLogo,
    tronProvider: "okx",
  },
  {
    id: "metamask",
    name: "MetaMask",
    chain: "evm",
    match: ["metamask"],
    installUrl: "https://metamask.io/download/",
    logo: metamaskLogo,
    tronProvider: "metamask",
  },
  {
    id: "imtoken",
    name: "IM Token",
    chain: "evm",
    match: ["imtoken"],
    installUrl: "https://token.im/download",
    logo: imtokenLogo,
    tronProvider: "imtoken",
  },
  {
    id: "mywallet",
    name: "My Wallet",
    chain: "evm",
    match: ["my wallet", "mywallet", "mytonwallet"],
    installUrl: "https://get.mywallet.io/",
    logo: mywalletLogo,
    tronProvider: "mywallet",
  },
  {
    id: "bybit",
    name: "Bybit",
    chain: "evm",
    match: ["bybit"],
    installUrl: "https://www.bybit.com/web3/",
    logo: bybitLogo,
    tronProvider: "bybit",
  },
  {
    id: "bitget",
    name: "Bitget",
    chain: "evm",
    match: ["bitget", "bitkeep"],
    installUrl: "https://web3.bitget.com/en/wallet-download",
    logo: bitgetLogo,
    tronProvider: "bitget",
  },
  {
    id: "tronlink",
    name: "Tron Link",
    chain: "tron",
    match: ["tronlink"],
    installUrl: "https://www.tronlink.org/",
    logo: tronlinkLogo,
    tronProvider: "tronlink",
  },
  {
    id: "coinbase",
    name: "Coinbase",
    chain: "evm",
    match: ["coinbase"],
    installUrl: "https://www.coinbase.com/wallet/downloads",
    logo: coinbaseLogo,
  },
  {
    id: "gemini",
    name: "Gemini",
    chain: "evm",
    match: ["gemini"],
    installUrl: "https://www.gemini.com/wallet",
    logo: geminiLogo,
  },
  {
    id: "phantom",
    name: "Phantom Wallet",
    chain: "evm",
    match: ["phantom"],
    installUrl: "https://phantom.app/download",
    logo: phantomLogo,
  },
]

export function getFeaturedWallet(id: string): FeaturedWallet | undefined {
  return featuredWallets.find((wallet) => wallet.id === id)
}

/** @deprecated Use `featuredWallets` — kept for backward-compatible imports. */
export const curatedWallets = featuredWallets

/** @deprecated WalletConnect is opened via “Other wallets”, not the featured grid. */
export const primaryConnectors: FeaturedWallet[] = []
